import Head from 'next/head';
import { useEffect } from 'react';
import { getWebUserId } from '../../Utils/helper';

export default function CategoryHeadElement(props) {
  const { categoryData, categoryId } = props;

  useEffect(() => {
    const event = new CustomEvent('page_view_kp', {
      detail: {
        type: 'collection',
        data: {
          cart_id: getWebUserId(),
          collection_id: categoryId,
          name: categoryData?.tabName,
          image_url: categoryData?.smart_icon || categoryData?.icon,
          handle: `https://mylofamily.com${categoryData?.webUrl}`,
        },
      },
    });
    window.dispatchEvent(event);
  }, [categoryData]);

  return (
    <>
      <Head></Head>
    </>
  );
}
